import React from "react";
import styled, { css } from "styled-components";
import { Formik, Form } from "formik";
import FormikInput from "components/common/FormikInput";
import Select from "components/common/Select";
import { Row, Col, Modal, Panel, ControlLabel } from "components/bootstrap";
import { ModalSubmit } from "components/common";
import NotificationExample from "./NotificationExample";
import NotificationHelp from "./Help";
const StyledRow = styled(Row)`
  margin-bottom: 0.5rem;

  .form-group {
    .title-label {
      width: 100%;
    }

    #longMessage {
      height: 8rem;
    }
  }
`;
const Title = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  .checkbox {
    margin: 0;
  }
`;
const ExampleHeader = styled.h4`
  margin-bottom: 0.75rem;
`;
const BooleanLabel = styled.span(
  ({ theme }) => css`
    span[role='button'] {
      margin-left: 6px;
      color: ${theme.colors.variant.light.default};
    }
  `
);
const LargeFormikInput = styled(FormikInput)(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.h4};
    margin: 0 21px 0 0;

    &.checkbox {
      > label {
        display: flex;
        padding-left: ${theme.fonts.size.h1};

        > input[type='checkbox'] {
          width: ${theme.fonts.size.h4};
          height: ${theme.fonts.size.h4};
          margin-left: -${theme.fonts.size.h1};
        }
      }
    }
  `
);
const NewNotice = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.variant.dark.default};
    font-style: italic;
    margin-right: ${theme.spacings.md};
  `
);
const ModalTitle = styled(Modal.Title)`
  flex: 1;
`;
const BehaviorFormikInput = styled(FormikInput)`
  margin: 0;
`;
const BehaviorHeading = styled(Panel.Heading)`
  padding: 6px 9px;
`;
const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const ModalForm = ({
  show,
  toggleShowModal,
  onSubmit,
  initialValues = {
    title: "",
    shortMessage: "",
    longMessage: "",
    isActive: true,
    isDismissible: false,
    atLogin: false,
    isGlobal: false,
    variant: "default",
    hiddenTitle: false
  },
  submitButtonText,
  submitLoadingText
}) => {
  const modalTitle = "Notification Message";
  return /* @__PURE__ */ React.createElement(Modal, { show, onHide: toggleShowModal, bsSize: "large" }, /* @__PURE__ */ React.createElement(Formik, { onSubmit, initialValues }, ({ isSubmitting, values, setFieldValue }) => {
    const changeColorVariant = (variant) => {
      setFieldValue("variant", variant);
    };
    return /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(ModalTitle, null, modalTitle), /* @__PURE__ */ React.createElement(LargeFormikInput, { type: "checkbox", name: "isActive", id: "is-active", label: "Active", formGroupClassName: "" })), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 8 }, /* @__PURE__ */ React.createElement(StyledRow, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        name: "title",
        id: "title",
        required: true,
        labelClassName: "title-label",
        label: /* @__PURE__ */ React.createElement(Title, null, /* @__PURE__ */ React.createElement("span", null, "Title"), /* @__PURE__ */ React.createElement(FormikInput, { type: "checkbox", name: "hiddenTitle", id: "hidden-title", label: "Hide Title" }))
      }
    ))), /* @__PURE__ */ React.createElement(StyledRow, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        label: "Short Message",
        name: "shortMessage",
        id: "short-message",
        help: "Message that will always appear.",
        required: true
      }
    )))), /* @__PURE__ */ React.createElement(Col, { sm: 4 }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 })), /* @__PURE__ */ React.createElement(Panel, null, /* @__PURE__ */ React.createElement(BehaviorHeading, null, /* @__PURE__ */ React.createElement(Panel.Title, null, "Behavior")), /* @__PURE__ */ React.createElement(Panel.Body, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
      BehaviorFormikInput,
      {
        type: "checkbox",
        name: "isDismissible",
        id: "is-dismissible",
        label: /* @__PURE__ */ React.createElement(BooleanLabel, null, /* @__PURE__ */ React.createElement("span", null, "Dismissible"), /* @__PURE__ */ React.createElement(NotificationHelp, { message: "Use can dismiss from their view during their current session" }))
      }
    )), /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
      BehaviorFormikInput,
      {
        type: "checkbox",
        name: "atLogin",
        id: "at-login",
        label: /* @__PURE__ */ React.createElement(BooleanLabel, null, /* @__PURE__ */ React.createElement("span", null, "Visible At Login"), /* @__PURE__ */ React.createElement(NotificationHelp, { message: "Visible above the Login fields" }))
      }
    )), /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
      BehaviorFormikInput,
      {
        type: "checkbox",
        name: "isGlobal",
        id: "is-global",
        label: /* @__PURE__ */ React.createElement(BooleanLabel, null, /* @__PURE__ */ React.createElement("span", null, "Visible Globally"), /* @__PURE__ */ React.createElement(NotificationHelp, { message: "Visible above content on every page" }))
      }
    )))))))), /* @__PURE__ */ React.createElement(StyledRow, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        label: "Read More Message",
        name: "longMessage",
        type: "textarea",
        help: '(optional) Message content of "Read More".',
        id: "long-message"
      }
    ))), /* @__PURE__ */ React.createElement(StyledRow, null, /* @__PURE__ */ React.createElement(Col, { sm: 6 }, /* @__PURE__ */ React.createElement(ControlLabel, { htmlFor: "variant" }, "Color Variant"), /* @__PURE__ */ React.createElement(
      Select,
      {
        clearable: false,
        name: "variant",
        id: "variant",
        options: [
          { label: "Default", value: "default" },
          { label: "Error", value: "danger" },
          { label: "Informative", value: "info" },
          { label: "Primary", value: "primary" },
          { label: "Success", value: "success" },
          { label: "Warning", value: "warning" }
        ],
        onChange: changeColorVariant,
        value: values.variant
      }
    ))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement("hr", null))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(ExampleHeader, null, "Example"), /* @__PURE__ */ React.createElement(
      NotificationExample,
      {
        title: values.title,
        bsStyle: values.variant,
        shortMessage: values.shortMessage,
        longMessage: values.longMessage,
        hiddenTitle: values.hiddenTitle,
        dismissible: values.isDismissible
      }
    )))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(Footer, null, /* @__PURE__ */ React.createElement(NewNotice, null, "Public Notifications may take a few moments to appear for your users."), /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        onCancel: toggleShowModal,
        isSubmitting,
        isAsyncSubmit: true,
        submitButtonText,
        submitLoadingText
      }
    ))));
  }));
};
export default ModalForm;
